import React from "react";

function ErrorPage() {
  return <div style={{minHeight:"70vh"}}>
    <h1 className="biggestText text-center">
      Oops!
    </h1>
  </div>;
}

export default ErrorPage;
